/* eslint-disable prettier/prettier */
export const loadConfig = async () => {
  const res = await fetch("/config.json");
  const config = await res.json();
  window.__CONFIG__ = config;
};